import * as React from "react";

/**
 * Creates a named context, provider, and hook
 *
 * @example
 * ```ts
 * const [useModalDisclosure, ModalDisclosureProvider] = createContext({ name: 'ModalDisclosureContext' })
 * ```
 */
export function createContext(options = {}) {
  const {
    strict = true,
    name = "Context",
    errorMessage = `use${name}: "context" is undefined. Seems you forgot to wrap component within the ${name}Provider`,
  } = options;

  const Context = React.createContext(undefined);

  Context.displayName = name;

  function useContext() {
    const context = React.useContext(Context);

    if (!context && strict) {
      const error = new Error(errorMessage);
      error.name = "ContextError";
      throw error;
    }

    return context;
  }

  return [useContext, Context.Provider, Context];
}
